module.exports = __webpack_public_path__ + "img/bg-02.d9be4e26.png";